/**
 * 客户端登录状态初始化插件。
 * 页面挂载后刷新当前用户，并把匿名用户或登录用户同步给 Sentry。
 */
export default defineNuxtPlugin(async () => {
  const { user, refreshUser } = useAuthUser();
  const { getAnonymousId } = useAnonymousUser();
  const { setUser } = useSentryClient();

  const nuxtApp = useNuxtApp();

  nuxtApp.hook("app:mounted", () => {
    void refreshUser();
  });

  watch(
    user,
    (currentUser) => {
      if (currentUser) {
        setUser({
          id: currentUser.id,
          email: currentUser.email,
          username: currentUser.name || currentUser.email,
        });
        return;
      }

      const anonymousId = getAnonymousId();
      setUser(anonymousId ? { id: anonymousId } : null);
    },
    { immediate: true },
  );
});
